import { Box, Chip, IconButton, Stack, Typography } from "@mui/material";
import HighlightOffRoundedIcon from "@mui/icons-material/HighlightOffRounded";
import { IconEnterprise } from "components/Icons/IconEnterprise";
import { formatCnpj } from "utils/Masks/Masks";

export default function CardMyCnpjs({
  name,
  cnpj,
  isActive,
  deleting,
  onRequestDelete,
  onChangeCnpj,
}) {
  const borderColor = isActive ? "#44BB3D" : deleting ? "#EB2128" : "#053462";

  return (
    <Stack
      direction="row"
      p="24px"
      border={`2px solid ${borderColor}`}
      alignItems="center"
      justifyContent="space-between"
      gap={2}
      mb="24px"
      sx={{ cursor: !deleting && !isActive ? "pointer" : "default" }}
      onClick={() => {
        if (!deleting && !isActive) onChangeCnpj({ name, cnpj });
      }}
    >
      <IconEnterprise width="60px" height="60px" color="#053462" />

      <Stack textAlign="left" flex={1}>
        <Typography fontSize={14} fontWeight={600} color="#636363">
          {formatCnpj(cnpj)}
        </Typography>
        <Typography fontSize={24} fontWeight={600} color="#053462" mt={0.5}>
          {name}
        </Typography>

        {isActive && (
          <Chip
            label="CNPJ ATIVO"
            size="small"
            sx={{
              mt: "6px",
              bgcolor: "#44BB3D",
              color: "#FFFFFF",
              fontWeight: 700,
              borderRadius: "16px",
              width: 100,
            }}
          />
        )}
      </Stack>

      <Box sx={{ width: 56, display: "flex", justifyContent: "flex-end" }}>
        {!isActive && !deleting && (
          <IconButton
            onClick={(e) => {
              e.stopPropagation();
              onRequestDelete({ name, cnpj });
            }}
          >
            <HighlightOffRoundedIcon sx={{ fontSize: 50, color: "#EB2128" }} />
          </IconButton>
        )}

        {deleting && (
          <HighlightOffRoundedIcon sx={{ fontSize: 50, color: "#EB2128" }} />
        )}
      </Box>
    </Stack>
  );
}
